import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialItemState: Dtos.TrialItem & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    trialItemTemplateId: null,
    trialItemTemplate: null,
    collectionInstanceId: null,
    collectionInstance: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    search: "",
    dataEntered: null,
    filesAdded: null,
    version: null
}

export interface ITrialItemReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    trialItemTemplateId: IFieldState<number>,
    collectionInstanceId: IFieldState<number>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    version: IFieldState<string>
}
